import { useAppSelector } from '@frontend/common';
import { AccountConstraintData, isAccountConstraintData } from '@frontend/constraint/types';
import { formStore, updateField, useAccountRepository } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { AccountConstraintDataInputProps } from './account-constraint-data-input.component';

interface ViewProps {
    formValues: AccountConstraintData;
}

const useAccountConstraintDataInput = (props: AccountConstraintDataInputProps): ViewProps => {
    const {
        store: { currentAccount }
    } = useAccountRepository();
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isAccountConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { account_id: currentAccount } }));
        }
    }, [currentAccount]);

    return {
        formValues
    };
};

export default useAccountConstraintDataInput;
